<template>
  <SettingsContainerDiv type="inner" :isSession="true">
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="resolution.title"
      :isSession="true"
      :description="resolution.description"
      :isSelect="true"
      :selectOptions="resolution.options"
      :currentSelection="resolution.current"
      @selected="updatePreference('resolution', $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="fps.title"
      :isSession="true"
      :description="fps.description"
      :isSelect="true"
      :selectOptions="fps.options"
      :currentSelection="fps.current"
      @selected="updatePreference('fps', $event)"
    >
    </SettingArea>
    <SettingArea
      :comingSoon="false"
      :isEnabled="false"
      :title="maxVideoBitrate.title"
      :isSession="true"
      :description="maxVideoBitrate.description"
      :isSelect="true"
      :selectOptions="maxVideoBitrate.options"
      :currentSelection="maxVideoBitrate.current"
      @selected="updatePreference('maxVideoBitrate', $event)"
    >
    </SettingArea>
  </SettingsContainerDiv>
</template>

<script>
import { mapState } from "vuex";
import SettingArea from "../../../../BookingPages/Settings/BaseComponents/SettingArea";
import SettingsContainerDiv from "../../../../BookingPages/Settings/BaseComponents/SettingsContainerDiv";
import { applyNewQualityPreferences } from "../../SessionHelpers/media";

export default {
  name: "SettingsQuality",
  data() {
    return {
      resolution: {
        title: "Resolution",
        description:
          "Lowering your resolution can improve quality in case of bad network. It also lowers CPU usage.",
        options: [
          { label: "Very high definition (1080p)", value: 1080 },
          { label: "High definition (720p Recommended)", value: 720 },
          { label: "Medium definition (480p)", value: 480 },
          { label: "Standard definition (360p)", value: 360 },
        ],
        current: null,
      },
      fps: {
        title: "FPS (Frames Per Second)",
        description:
          "Lowering FPS can improve quality in case of bad network. It also lowers CPU usage.",
        options: [
          { label: "30 fps", value: 30 },
          { label: "24 fps (Recommended)", value: 24 },
          { label: "15 fps", value: 15 },
        ],
        current: null,
      },
      maxVideoBitrate: {
        title: "MVB (Max Video Bitrate)",
        description:
          "Lowering MVB can improve quality in case of bad network. It also lowers CPU usage.",
        options: [
          { label: "Automatic (default)", value: -1 },
          { label: "2000000 bps (bit per second)", value: 2000000 },
          { label: "500000 bps (bit per second)", value: 500000 },
        ],
        current: null,
      },
    };
  },
  components: {
    SettingArea,
    SettingsContainerDiv,
  },
  computed: {
    ...mapState({
      sessionPreferences: (state) => state.room.sessionPreferences,
    }),
  },
  mounted() {
    this.setCurrentQualitySettings();
  },
  methods: {
    setCurrentQualitySettings() {
      const preferences = this.sessionPreferences;

      this.resolution.current = preferences.resolution || 720;
      this.fps.current = preferences.fps || 24;
      this.maxVideoBitrate.current = preferences.maxVideoBitrate || -1;
    },
    async updatePreference(preference, newValue) {
      if (!preference || !newValue) {
        return console.warn("missing preference type or newValue");
      }
      console.log("preference, value", preference, newValue);
      /* 1. Update Vuex preferences */
      const updateData = { field: preference, newValue };
      await this.$store.dispatch("room/updatePreferenceField", updateData);

      /* 2. Update current in passed options */
      this[preference].current = newValue;

      /* 3. Apply new quality preferences */
      await applyNewQualityPreferences();
    },
  },
};
</script>